module.exports = __webpack_public_path__ + "static/img/manual-11.bb146ea.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-11.png
// module id = gShl
// module chunks = 4